export default __webpack_public_path__ + "static/media/logo-pool-2.8f9026e3.png";